import { render } from "./NotificationSettingsGrid.vue?vue&type=template&id=816d43f8"
import script from "./NotificationSettingsGrid.vue?vue&type=script&lang=js"
export * from "./NotificationSettingsGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__